/* Better Days Customs - artwork placement preview.
   Client side only. Renders the customer's artwork over the garment photo so they
   can see roughly where it lands, then hands the file to the quote form.
   This is a preview, not a proof. Nothing here is used for production output. */
(function () {
  var MAX_MB = 20;
  var OK = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];

  function BDCStudio(root) {
    this.root = root;
    this.stage = root.querySelector('[data-studio-stage]');
    this.art = root.querySelector('[data-studio-art]');
    this.input = root.querySelector('[data-studio-file]');
    this.drop = root.querySelector('[data-studio-drop]');
    this.err = root.querySelector('[data-studio-error]');
    this.name = root.querySelector('[data-studio-name]');
    this.scale = root.querySelector('[data-studio-scale]');
    this.reset = root.querySelector('[data-studio-reset]');
    this.clear = root.querySelector('[data-studio-clear]');
    this.placementInputs = root.querySelectorAll('[data-studio-placement]');
    this.state = { x: 50, y: 42, s: 34, dragging: false };
    this.bind();
    this.apply();
  }

  BDCStudio.prototype.fail = function (msg) {
    if (!this.err) return;
    this.err.textContent = msg;
    this.err.hidden = !msg;
  };

  BDCStudio.prototype.load = function (file) {
    var self = this;
    if (!file) return;
    if (OK.indexOf(file.type) === -1) {
      return self.fail('That file type will not preview. Use PNG, JPG, WEBP or SVG. You can still send AI, EPS or PDF with your quote request, it just will not show here.');
    }
    if (file.size > MAX_MB * 1024 * 1024) {
      return self.fail('That file is over ' + MAX_MB + 'MB. Send a smaller version here and email us the full resolution file.');
    }
    self.fail('');
    var reader = new FileReader();
    reader.onload = function (e) {
      self.art.src = e.target.result;
      self.art.hidden = false;
      self.root.classList.add('has-art');
      if (self.name) self.name.textContent = file.name;
      self.state.x = 50; self.state.y = 42; self.state.s = 34;
      if (self.scale) self.scale.value = 34;
      self.apply();
    };
    reader.readAsDataURL(file);
  };

  BDCStudio.prototype.apply = function () {
    if (!this.art) return;
    this.art.style.left = this.state.x + '%';
    this.art.style.top = this.state.y + '%';
    this.art.style.width = this.state.s + '%';
  };

  BDCStudio.prototype.point = function (e) {
    var r = this.stage.getBoundingClientRect();
    var t = e.touches ? e.touches[0] : e;
    this.state.x = Math.min(92, Math.max(8, ((t.clientX - r.left) / r.width) * 100));
    this.state.y = Math.min(92, Math.max(8, ((t.clientY - r.top) / r.height) * 100));
    this.apply();
  };

  BDCStudio.prototype.bind = function () {
    var self = this;

    if (this.input) {
      this.input.addEventListener('change', function () { self.load(self.input.files[0]); });
    }
    if (this.drop) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        self.drop.addEventListener(ev, function (e) { e.preventDefault(); self.drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        self.drop.addEventListener(ev, function (e) { e.preventDefault(); self.drop.classList.remove('is-over'); });
      });
      this.drop.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          if (self.input) {
            try { self.input.files = e.dataTransfer.files; } catch (err) {}
          }
          self.load(e.dataTransfer.files[0]);
        }
      });
    }

    if (this.stage) {
      this.stage.addEventListener('mousedown', function (e) {
        if (!self.root.classList.contains('has-art')) return;
        self.state.dragging = true; self.point(e); e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) { if (self.state.dragging) self.point(e); });
      document.addEventListener('mouseup', function () { self.state.dragging = false; });
      this.stage.addEventListener('touchstart', function (e) {
        if (!self.root.classList.contains('has-art')) return;
        self.state.dragging = true; self.point(e);
      }, { passive: true });
      this.stage.addEventListener('touchmove', function (e) {
        if (self.state.dragging) { self.point(e); e.preventDefault(); }
      }, { passive: false });
      this.stage.addEventListener('touchend', function () { self.state.dragging = false; });
    }

    if (this.scale) {
      this.scale.addEventListener('input', function () {
        self.state.s = parseFloat(self.scale.value); self.apply();
      });
    }
    if (this.reset) {
      this.reset.addEventListener('click', function () {
        self.state.x = 50; self.state.y = 42; self.state.s = 34;
        if (self.scale) self.scale.value = 34;
        self.apply();
      });
    }
    if (this.clear) {
      this.clear.addEventListener('click', function () {
        self.art.hidden = true; self.art.removeAttribute('src');
        self.root.classList.remove('has-art');
        if (self.input) self.input.value = '';
        if (self.name) self.name.textContent = '';
        self.fail('');
      });
    }

    // swap the garment photo when a placement is chosen, if a back image exists
    Array.prototype.forEach.call(this.placementInputs, function (inp) {
      inp.addEventListener('change', function () {
        var wants = (inp.value || '').toLowerCase();
        var base = self.stage.querySelector('[data-studio-base]');
        if (!base) return;
        var front = base.getAttribute('data-front');
        var back = base.getAttribute('data-back');
        base.src = (wants.indexOf('back') > -1 && back) ? back : front;
      });
    });
  };

  function boot() {
    var nodes = document.querySelectorAll('[data-bdc-studio]');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__bdc) { nodes[i].__bdc = new BDCStudio(nodes[i]); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
